<template>
  <div class="modal-wrapper">
    <a-modal
      :visible="visible"
      :title="title"
      :okText="okText"
      :cancelText="cancelText"
      @cancel="handleClose"
    >
      <slot></slot>
      <template slot="footer">
        <div :class="['custom-modal-footer', `align-${buttonAlign}`]">
          <!-- 按钮位置可通过CSS灵活调整 -->
          <a-button type="primary" @click="handleOk">{{ okText }}</a-button>
          <a-button @click="handleCancel">{{ cancelText }}</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "默认标题",
    },
    buttonText: {
      type: String,
      default: "打开模态框",
    },
    okText: {
      type: String,
      default: "确定",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    handleOk: {
      type: Function,
      required: true,
    },
    // 新增：从外部传入取消处理方法
    handleCancel: {
      type: Function,
      required: true, // 要求父组件必须传入取消逻辑
    },
    handleClose: {
      type: Function,
      required: true, // 要求父组件必须传入x逻辑
    },
    buttonAlign: {
      type: String,
      default: "right", // 默认右对齐（保持原生风格）
      validator: (value) => {
        // 限制只能传入指定值
        return ["left", "center", "right"].includes(value);
      },
    },
  },
  methods: {},
};
</script>
<style scoped>
.custom-modal-footer {
  padding: 16px;
}

/* 按钮之间的间距 */
.custom-modal-footer .ant-btn + .ant-btn {
  margin-left: 8px;
}

/* 左对齐 */
.align-left {
  text-align: left;
}

/* 居中对齐 */
.align-center {
  text-align: center;
}

/* 右对齐（默认） */
.align-right {
  text-align: right;
}
</style>
